// Applique un ordre + masquage sauvegardés à une liste de menu de base.
// `layout` = { order: [to...], hidden: [to...] }. Les nouveaux items non listés
// dans `order` sont ajoutés à la fin dans leur ordre d'origine.
export function applyMenuLayout(base, layout) {
  const hidden = new Set((layout && layout.hidden) || []);
  if (!layout || !Array.isArray(layout.order) || layout.order.length === 0) {
    return base.filter((i) => !hidden.has(i.to));
  }
  const byKey = new Map(base.map((i) => [i.to, i]));
  const ordered = [];
  layout.order.forEach((k) => {
    if (byKey.has(k)) {
      ordered.push(byKey.get(k));
      byKey.delete(k);
    }
  });
  base.forEach((i) => {
    if (byKey.has(i.to)) ordered.push(i);
  });
  return ordered.filter((i) => !hidden.has(i.to));
}
